import { createContext, useContext } from 'react';
import type { IUseCustomContentAvailabilityResult } from 'hooks/useCustomContentAvailability';

const defaultCustomContentAvailability: IUseCustomContentAvailabilityResult = {
  hasCustomContent: false,
  isCheckingCustomContent: true,
  refreshCustomContentAvailability: async () => false,
};

export const CustomContentAvailabilityContext = createContext<IUseCustomContentAvailabilityResult>(
  defaultCustomContentAvailability
);

export const useCustomContentAvailabilityContext = (): IUseCustomContentAvailabilityResult => {
  return useContext(CustomContentAvailabilityContext);
};
